import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import LazyPlaceholder from '../LazyPlaceholder';

import s from './LoadingPlaceholder.scss';

/*
  So design wants the transfer between our placeholder and our comment box editor to be smoother. Their request
  was to remove the loading indicator completely, but that has potential UX problems if a user has a slow connection and we
  can't fetch the editor js chunk fast enough. So we reformat the loading indicator here to appear where the editor controls will
  eventually pop up.

  The ms I decided on was based on the research here: https://www.nngroup.com/articles/response-times-3-important-limits/
  TLDR: 100ms is breakpoint for something to be percieved by the average person as not instant/connected to their input.
*/

export interface Props {}

/** What we'll show while we're waiting for the DaEditor chunk to load. */
const LoadingPlaceholder: React.FC<Props> = () => {
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    /*
      One more note: we give a 25ms window for the animation to have time to spin up, want to start giving
      that feedback before we hit that 100ms breakpoint
    */
    const timeout = setTimeout(() => setShowLoader(true), 75);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <>
      <LazyPlaceholder />
      <LoadingIndicator className={classnames(s['loader'], showLoader && s['shown'])} />
    </>
  );
};
LoadingPlaceholder.displayName = 'LoadingPlaceholder';

export default LoadingPlaceholder;
